<template>
  <div>
    <div v-if="term.current">
      <v-card
        class="mb-4"
        :loading="loadingJustifications"
        v-if="$_hasRole('student')"
      >
        <v-system-bar
          ><v-badge dot left inline :value="justificationsStudent.length > 0"
            >Begründungen pendent bei mir</v-badge
          ></v-system-bar
        >
        <JustificationList :items="justificationsStudent" hideStudent />
      </v-card>

      <v-card class="mb-4" :loading="loadingJustifications">
        <v-system-bar v-if="$_hasRole('teacher')">
          <v-badge
            dot
            left
            inline
            :value="justificationsTeacherPending.length > 0"
            >Begründungen pendent bei mir</v-badge
          >
        </v-system-bar>
        <v-system-bar v-else>
          <v-badge dot left inline :value="false"
            >Begründungen pendent bei Klassenlehrperson</v-badge
          >
        </v-system-bar>
        <JustificationList :items="justificationsTeacherPending" hideStudent />
      </v-card>

      <v-card class="mb-4" :loading="loadingJustifications">
        <v-system-bar v-if="$_hasRole('teacher')">
          <v-badge
            dot
            left
            inline
            :value="justificationsTeacherApproved.length > 0"
            >Begründungen aktuell (bewilligt aber noch nicht vorbei)</v-badge
          >
        </v-system-bar>
        <v-system-bar v-else>
          <v-badge dot left inline :value="false"
            >Begründungen aktuell (bewilligt aber noch nicht vorbei)</v-badge
          >
        </v-system-bar>
        <JustificationList :items="justificationsTeacherApproved" hideStudent />
      </v-card>

      <v-card
        class="mb-4"
        outlined
        :loading="loadingJustifications"
        v-if="!$_hasRole('student')"
      >
        <v-system-bar>
          <v-badge dot left inline :value="false"
            >Begründungen pendent bei Schüler:in</v-badge
          ></v-system-bar
        >
        <JustificationList :items="justificationsStudent" hideStudent />
      </v-card>

      <v-card class="mb-4" :loading="loadingAbsences">
        <v-system-bar
          ><v-badge
            dot
            left
            inline
            :value="$_hasRole('student') && absencesPending.length > 0"
            >Absenzen ohne Begründung</v-badge
          ></v-system-bar
        >
        <AbsenceList
          :items="absencesPending"
          @updated="
            fetchData();
            $emit('updated');
          "
          hideStudent
          :actions="['delete', 'unexcuse', 'ignore']"
        />
      </v-card>

      <router-view
        @updated="fetchData()"
        :id="id"
        :student="student"
        :schoolClass="student.schoolClass"
      />
    </div>
    <div v-else>
      <v-alert type="info" text prominent>
        Pendenzen können nur im aktuellen Semester eingesehen werden.
      </v-alert>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import AbsenceList from "common/components/AbsenceList.vue";
import JustificationList from "common/components/JustificationList.vue";
import JustificationHeatmap from "common/components/Absences/JustificationHeatmap.vue";

export default defineComponent({
  components: {
    AbsenceList,
    JustificationList,
    JustificationHeatmap,
  },
  props: {
    id: { type: Number, default: 0 },
    student: { type: Object, default: () => ({}) },
    term: { startDate: 0 },
  },
  data() {
    return {
      dialog: false,
      loadingAbsences: false,
      loadingJustifications: false,
      absencesPending: [],
      justificationsStudent: [],
      justificationsTeacher: [],
    };
  },
  computed: {
    absencesDialog() {
      if (this.eventIndex < 0 || !this.events[this.eventIndex]) {
        return [];
      }
      return this.events[this.eventIndex].absences;
    },
    canEdit() {
      return this.$_isClassTeacherOf(this.student);
    },
    pendingCount() {
      if (this.$_hasRole("student")) {
        const absencesCount = Math.min(this.absencesPending.length, 1);
        return this.justificationsStudent.length + absencesCount;
      }
      return this.justificationsTeacherPending.length;
    },

    justificationsTeacherApproved() {
      return this.justificationsTeacher.filter(
        (el) => el.status.code == "approved"
      );
    },
    justificationsTeacherPending() {
      return this.justificationsTeacher.filter(
        (el) => el.status.code == "submitted" || el.status.code == "created"
      );
    },
  },
  watch: {
    id(oldValue, newValue) {
      if (oldValue != newValue) {
        this.fetchData();
      }
    },
  },

  methods: {
    async absenceDeleted() {
      if (this.absencesDialog.length == 1) {
        this.dialog = false;
      }
      await this.fetchAbsences();
    },
    async fetchAbsences() {
      this.loadingAbsences = true;

      this.absencesPending = await this.apiList({
        resource: "absence/absence",
        query: `student=${this.id}&pending`,
      });

      this.loadingAbsences = false;
    },
    async fetchJustifications() {
      this.loadingJustifications = true;

      this.justificationsTeacher = await this.apiList({
        resource: "absence/justification",
        query: `status=pendingTeacher&student=${this.id}&startDate=${this.term.startDate}&endDate=${this.term.endDate}`,
      });

      this.justificationsStudent = await this.apiList({
        resource: "absence/justification",
        query: `status=pendingStudent&student=${this.id}&startDate=${this.term.startDate}&endDate=${this.term.endDate}`,
      });

      this.loadingJustifications = false;
    },

    async fetchData() {
      if (!this.id) return;
      await this.fetchAbsences();
      await this.fetchJustifications();
    },

    showDetails(el) {
      if (el.event.id) {
        if (this.$_hasRole("student")) {
          this.$router.push({
            name: "JustificationStudentDetail",
            params: { id: this.id, justificationId: el.event.id },
          });
        } else {
          this.$router.push({
            name: "JustificationOverviewDetail",
            params: { id: this.id, justificationId: el.event.id },
          });
        }
      } else if (el.event.absences) {
        this.eventIndex = this.events.findIndex(
          (event) => event.date == el.event.date
        );
        this.dialog = true;
      }
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
